import {
  PORTFOLIOS_QUERY_KEY,
  PORTFOLIO_QUERY_KEY,
} from '@/hooks/portfolio/usePortfolio';
import {
  WATCHLISTS_QUERY_KEY,
  WATCHLIST_QUERY_KEY,
} from '@/hooks/useWatchlist';
import { useQueryClient } from '@tanstack/react-query';
import { useNarrativeValuationOptions } from '@/components/NarrativeFairValue/components/NarrativeFairValueModal/hooks/useNarrativeValuationOptions';
import { useNarrativeById } from '../useNarrativeById';

type InvalidateOptions = {
  companyId: string;
  narrativeId?: string;
  skip?: 'narrativeValuationOptions'[];
};

export const useNarrativeInvalidate = () => {
  const queryClient = useQueryClient();

  const invalidate = async ({
    companyId,
    narrativeId,
    skip = [],
  }: InvalidateOptions) => {
    !skip.includes('narrativeValuationOptions') &&
      (await queryClient.invalidateQueries(
        useNarrativeValuationOptions.getOptions({ companyId })
      ));

    // BEGIN NOTE: Temporarily invalidating all the data so the
    // pages which use narrativeFairValue will always be in sync
    await queryClient.invalidateQueries({
      queryKey: PORTFOLIOS_QUERY_KEY,
    });
    await queryClient.invalidateQueries({
      queryKey: WATCHLISTS_QUERY_KEY,
    });
    await queryClient.invalidateQueries({
      queryKey: [PORTFOLIO_QUERY_KEY],
      exact: false,
    });
    await queryClient.invalidateQueries({
      queryKey: [...WATCHLIST_QUERY_KEY],
      exact: false,
    });

    narrativeId &&
      (await queryClient.invalidateQueries(
        useNarrativeById.getOptions({ narrativeId })
      ));
    // END NOTE
  };

  return {
    invalidate,
  };
};
